var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.495 12C3.495 10.2045 4.9545 8.745 6.75 8.745H10.95V6.75H6.75C3.852 6.75 1.5 9.102 1.5 12C1.5 14.898 3.852 17.25 6.75 17.25H10.95V15.255H6.75C4.9545 15.255 3.495 13.7955 3.495 12ZM7.5 12.75H15.9V11.25H7.5V12.75ZM17.25 6.75H13.05V8.745H17.25C19.0455 8.745 20.505 10.2045 20.505 12C20.505 13.7955 19.0455 15.255 17.25 15.255H13.05V17.25H17.25C20.148 17.25 22.5 14.898 22.5 12C22.5 9.102 20.148 6.75 17.25 6.75Z"
})));
export default SvgShare;